// extracted by mini-css-extract-plugin
export default {"wrapper":"AXoKWeZPnXDQ1M3qdUdY","historyButton":"UfHq0yyqUA5TlP3kkHsf","icon":"iSejKd9ZUd3G5U_IMalF"};